global.$ = global.jQuery = require("jquery");

const semver = require("semver");

import "bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "vant/lib/index.css";
import "./mixins/helpers";

import Vue from "vue";

import VueI18n from "vue-i18n";
Vue.use(VueI18n);

import * as VueGoogleMaps from "vue2-google-maps";

import VueScrollTo from "vue-scrollto";
Vue.use(VueScrollTo, {
  duration: 500,
});

Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyCcSkAmg-YAAbAP7THraKBBkorR2-c1g_Q",
  },
  installComponents: true,
});

import "es6-promise/auto";

import Vuex from "vuex";
Vue.use(Vuex);

import { Dialog, Button, Loading, Skeleton } from "vant";
Vue.use(Dialog);
Vue.use(Button);
Vue.use(Loading);
Vue.use(Skeleton);

import axios from "./plugins/axios";
Vue.prototype.$axios = axios;

// Fontawesome PRO
import "./assets/scss/fontawesome-pro/scss/fontawesome.scss";
import "./assets/scss/fontawesome-pro/scss/regular.scss";
import "./assets/scss/fontawesome-pro/scss/solid.scss";
import "./assets/scss/fontawesome-pro/scss/brands.scss";
import "./assets/scss/fontawesome-pro/scss/light.scss";

import App from "./App.vue";
import Maintenance from "./Maintenance.vue";
import NewAppVersion from "./NewAppVersion.vue";
import loadRecaptcha from './components/mixins/loadRecaptcha'

Vue.config.productionTip = false;

import "./router/langRouting";

import store from "./store/index";
import router from "./router/router";

import VueGtag from "vue-gtag";
Vue.use(VueGtag, {
  config: { id: process.env.VUE_APP_GOOGLE_ANALYTICS_ID },
});

import VueTagManager from "vue-tag-manager";
Vue.use(VueTagManager, {
  gtmId: process.env.VUE_APP_GOOGLE_TAG_MANAGER,
});

import messages from "./i18n/messages.js";
const i18n = new VueI18n({
  locale: store.getters["language/getLanguage"],
  fallbackLocale: "en",
  messages,
});

Vue.prototype.$eventBus = new Vue();

Vue.mixin({
  methods: {
    startLoading() {
      this.$store.dispatch("loading/startLoading");
    },
    stopLoading() {
      this.$store.dispatch("loading/stopLoading");
    },
    appUrl(path) {
      return process.env.VUE_APP_URL + path;
    },
  },
});

const vue = new Vue({
  mixins: [
    loadRecaptcha
  ],
  router,
  i18n,
  store,
  computed: {
    maintenance() {
      return this.$store.getters["settings/getMaintenance"];
    },
  },
  methods: {
    newAppVersion(device) {
      return this.$store.getters["settings/getAppVersion"](device);
    },

    normalizeVersion(version) {
      if (version == 0 || version == "0") {
        return false;
      }

      var split = String(version).split(".");
      if (split.length == 2) {
        return split.join(".") + ".0";
      }

      return String(version);
    },
  },
  async created() {
    await this.$store.dispatch("settings/getSettings");
    this.insertRecaptchaJs();
  },
  mounted() {
    this.$gtag.time({
      name: "load",
      value: new Date(),
      event_category: "JS Dependencies",
    });

    this.$gtag.config({
      id: process.env.VUE_APP_GOOGLE_ANALYTICS_ID,
    });

    this.$gtag.query("config", process.env.VUE_APP_GOOGLE_ADWORDS_ID);

    // document.addEventListener('deviceready', function() {
    //
    //   //mobile status bar color ios & android
    //   if(window.cordova && StatusBar) {

    // if(process.env.VUE_APP_DEVICE == 'android') {
    //   StatusBar.overlaysWebView(true);
    // }
    // else {
    //   StatusBar.overlaysWebView(false);
    // }

    //     StatusBar.backgroundColorByHexString('#000');
    //   }
    // })
  },
  render: function(createElement) {
    //only on mobile
    let device = process.env.VUE_APP_DEVICE;
    if (device != "desktop") {
      console.log(`App version (${device}): ${process.env.VUE_APP_MOBILE_VERSION} - Mode: ${process.env.NODE_ENV}`);
      if (
        this.normalizeVersion(this.newAppVersion(device)) &&
        semver.gt(
          this.normalizeVersion(this.newAppVersion(device)),
          this.normalizeVersion(process.env.VUE_APP_MOBILE_VERSION)
        )
      ) {
        return createElement(NewAppVersion);
      }
    }

    let template = this.maintenance ? Maintenance : App;
    return createElement(template);
  },
}).$mount("#app");

window.getStoreInstance = function() {
  return store;
};

window.getRouterInstance = function() {
  return router;
};

window.getVueInstance = function() {
  return vue;
};